import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import { WindowTitle } from "../../components/WindowTitle";
import {
  FinanceOrderListUrlQueryParams,
  FinanceOrderListUrlSortField
} from "./urls";
import FinanceOrderList from "./views/FinanceOrderList";

const FinanceOrdersList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params = asSortParams(
    qs,
    FinanceOrderListUrlSortField,
    FinanceOrderListUrlSortField.date
  ) as FinanceOrderListUrlQueryParams;
  return <FinanceOrderList params={params} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.orders)} />
      <Routes>
        <Route path={""} element={<FinanceOrdersList />} />
      </Routes>
    </>
  );
};

export default Component;
